import tabs from "containers/Enterprise/OrgProjects/tabs";
import { ProjectsIcon } from "@icons";
import { permissionTypes } from "hooks/usePermissions";
import breadCrumbs from "components/PlatformLayout/components/PlatformPageHeader/Breadcrumbs/ProjectBreadCrumbs";
import l from "@loadable/component";

const content = l(() => import("containers/Enterprise/OrgProjects"));

const { ENTERPRISE_SUPPORT, ENTERPRISE_ADMIN } = permissionTypes;

export default {
  key: "org-projects",
  title: breadCrumbs,
  path: "/org-projects/:tab?",
  exact: true,
  basePath: "org-projects",
  requiredParams: ["tab"],
  optionalParams: ["projectId"],
  linkTarget: "/org-projects",
  linkTitle: "Pipeline",
  linkCategory: "Enterprise",
  icon: ProjectsIcon,
  permission: [ENTERPRISE_SUPPORT, ENTERPRISE_ADMIN],
  tabs,
  content,
};
